import { useEffect } from "react";
import { connect } from "react-redux";
import { Row, List, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import Box from '../../components/utility/box';
import systemActions from '../../redux/systemInfos/actions';
import IntlMessages from '../../components/utility/intlMessages';

const { Title } = Typography;

const { getGeneralErrorLogs } = systemActions;

function GeneralLog(props) {
  useEffect(() => {
    props.getGeneralErrorLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getMessage = (message, containsError) => {
    return containsError
      ? <Typography.Text type={'danger'}>{message}</Typography.Text>
      : <Typography.Text>{message}</Typography.Text>
  }

  const generalLogListItemFactory = record => {
    return (
      <List.Item>
        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <IntlMessages id="general.message" />: {getMessage(record.message, record.containsError)}
          </Col>
        </Row>
      </List.Item>
    );
  }

  return (
    <Box>
      <Row>
        <Col span={24}>
          <Title level={4} style={{ textAlign: "center" }}>
            <IntlMessages id="homePage.generalLogs.title" />
          </Title>
          <a href={process.env.REACT_APP_KIBANA_HOST} target="_blank" rel="noopener noreferrer">
            <IntlMessages id="general.lookOnKibana" />
          </a>
          <List
            style={{ maxHeight: "700px", overflowY: 'auto' }}
            bordered
            dataSource={props.data.logs}
            renderItem={generalLogListItemFactory}
          />
        </Col>
      </Row>
    </Box>

  )
}

GeneralLog.propTypes = {
  data: PropTypes.object.isRequired,

  getGeneralErrorLogs: PropTypes.func.isRequired,
};

GeneralLog.defaultProps = {
  data: {
    numberOfLogs: 0,
    logs: []
  }
}

const mapActionsToProps = {
  getGeneralErrorLogs,
};

function mapStateToProps(state) {
  return {
    data: state.SystemInfos.get('generalLogs'),
  };
}

const connectedGeneralLog = connect(mapStateToProps, mapActionsToProps)(GeneralLog);
export default connectedGeneralLog;